export const PresupuestoHelper = {
  baseUrl: process.env.REACT_APP_BASE_URL,
  rutaTabla: "Presupuesto",
  constructor(baseUrl) {
    this.baseUrl = baseUrl;
  },

  //Consulta a la API
  fetchData: async function (accessToken) {
    try {
      const response = await fetch(`${this.baseUrl}/${this.rutaTabla}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`, // Incluye el token en la cabecera de la solicitud.
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error", error);
      return null;
    }
  },

  //Consulta a la API
  fetchDataSourcing: async function (accessToken) {
    try {
      const response = await fetch(`${this.baseUrl}/${this.rutaTabla}/sourcing`, {
        headers: {
          Authorization: `Bearer ${accessToken}`, // Incluye el token en la cabecera de la solicitud.
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error", error);
      return null;
    }
  },

  fetchDataSourcing_Id_Pais: async function ( name, id, accessToken) {
    try {
      const response = await fetch(`${this.baseUrl}/${this.rutaTabla}/sourcing/idpais/${name}/${id}/si`, {
        headers: {
          Authorization: `Bearer ${accessToken}`, // Incluye el token en la cabecera de la solicitud.
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error", error);
      return null;
    }
  },

  fetchDataSourcing_PO_Id_Pais: async function ( name, id, accessToken) {
    try {
      const response = await fetch(`${this.baseUrl}/${this.rutaTabla}/sourcingpo/idpais/${name}/${id}/si`, {
        headers: {
          Authorization: `Bearer ${accessToken}`, // Incluye el token en la cabecera de la solicitud.
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error", error);
      return null;
    }
  },

  fetchDataInbound: async function (accessToken) {
    try {
      const response = await fetch(`${this.baseUrl}/${this.rutaTabla}/inbound`, {
        headers: {
          Authorization: `Bearer ${accessToken}`, // Incluye el token en la cabecera de la solicitud.
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error", error);
      return null;
    }
  },

  fetchDataInbound_Id_Pais: async function ( name, id, accessToken) {
    try {
      const response = await fetch(`${this.baseUrl}/${this.rutaTabla}/inbound/idpais/${name}/${id}/si`, {
        headers: {
          Authorization: `Bearer ${accessToken}`, // Incluye el token en la cabecera de la solicitud.
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error", error);
      return null;
    }
  },

  //Consulta a la API
  fetchDataVS: async function (idPais, accessToken) {
    try {
      const response = await fetch(`${this.baseUrl}/Vs/embarques/pais/${idPais}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`, // Incluye el token en la cabecera de la solicitud.
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error", error);
      return null;
    }
  },

  fetchOwnersList: async function (accessToken) {
    try {
      const response = await fetch(`${this.baseUrl}/${this.rutaTabla}/owners`, {
        headers: {
          Authorization: `Bearer ${accessToken}`, // Incluye el token en la cabecera de la solicitud.
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error", error);
      return null;
    }
  },

  fetchDataUltimosEstadios: async function ( estnumber, accessToken) {
    try {
      const response = await fetch(`${this.baseUrl}/recentlist/${estnumber}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`, // Incluye el token en la cabecera de la solicitud.
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error", error);
      return null;
    }
  },
  EstimateDisponibleNum: async function (accessToken) {
    try {
      const response = await fetch(`${this.baseUrl}/EstimateHeader/detalles`, {
        headers: {
          Authorization: `Bearer ${accessToken}`, // Incluye el token en la cabecera de la solicitud.
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error", error);
      return null;
    }
  },
  EstimateDisponibleVers: async function (estnumber, accessToken) {
    try {
      const response = await fetch(
        `${this.baseUrl}/EstimateHeader/detalles/${estnumber}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`, // Incluye el token en la cabecera de la solicitud.
          },
        }
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error", error);
      return null;
    }
  },
  //Consulta a la API doble entrada
  readDataEstVers: async function (estnumber, vers, accessToken) {
    try {
      const response = await fetch(
        `${this.baseUrl}/${this.rutaTabla}/${estnumber}/${vers}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error", error);
      return null;
    }
  },
  //Consulta a la API de VirtualSeller
  readDataVirtualSellerById: async function (vs_id, accessToken) {
    try {
      const response = await fetch(
        `${this.baseUrl}/Vs/octoesti/${vs_id}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (!response.ok) {
        // throw new Error(`HTTP error! status: ${response.status}`);
        const errorMessage = await response.text(); // o response.json() si el servidor envía una respuesta JSON
        console.error('ErrorResponse:', errorMessage);
        throw new Error(errorMessage);
            }
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Helper Error", error.message);
      return error;
    }
  },
  //CRUD PRESUPUESTO
  // Crear un registro en la tabla
  createDataSourcing: async function (newData, accessToken) {
    try {
      const response = await fetch(`${this.baseUrl}/${this.rutaTabla}/sourcing`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization : `Bearer ${accessToken}`,
        },
        body: JSON.stringify(newData),
      });
      if (!response.ok) {
        // Lanzar un error si el servidor responde con un estado de error
        const errorMessage = await response.text(); // O response.json() si el error es un objeto JSON
        throw new Error(errorMessage);
      }

      const jsonData = await response.json();
      console.log("Helper", newData);
      return jsonData;
    } catch (error) {
      console.error("Helper Error", error.message);
      throw error;
    }
  },
  createDataSourcing_PO: async function (newData, accessToken) {
    try {
      const response = await fetch(`${this.baseUrl}/${this.rutaTabla}/sourcingpo`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization : `Bearer ${accessToken}`,
        },
        body: JSON.stringify(newData),
      });
      if (!response.ok) {
        // Lanzar un error si el servidor responde con un estado de error
        const errorMessage = await response.text(); // O response.json() si el error es un objeto JSON
        throw new Error(errorMessage);
      }

      const jsonData = await response.json();
      console.log("Helper", newData);
      return jsonData;
    } catch (error) {
      console.error("Helper Error", error.message);
      throw error;
    }
  },
  createDataInbound: async function (newData, accessToken) {
    try {
      const response = await fetch(`${this.baseUrl}/${this.rutaTabla}/inbound`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization : `Bearer ${accessToken}`,
        },
        body: JSON.stringify(newData),
      });
      if (!response.ok) {
        // Lanzar un error si el servidor responde con un estado de error
        const errorMessage = await response.text(); // O response.json() si el error es un objeto JSON
        throw new Error(errorMessage);
      }

      const jsonData = await response.json();
      console.log("Helper", newData);
      return jsonData;
    } catch (error) {
      console.error("Helper Error", error.message);
      throw error;
    }
  },
  // Crear un registro en la tabla
  createNewPresupuesto: async function (newData, estnumber, accessToken) {
    try {

      const response = await fetch(
        `${this.baseUrl}/${this.rutaTabla}/${estnumber}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify(newData),
        }
      );
      if (!response.ok) {
        // Lanzar un error si el servidor responde con un estado de error
        const errorMessage = await response.text(); // O response.json() si el error es un objeto JSON
        throw new Error(errorMessage);
      }

      const jsonData = await response.json();
      console.log("Helper", newData);
      return jsonData;
    } catch (error) {
      console.error("Helper Error", error);
      throw error; // Lanzamos el error para que pueda ser capturado por el código que llama a esta función
    }
  },
  // Leer un registro de la tabla por ID
  readDataById: async function (id, accessToken) {
    try {
      const response = await fetch(`${this.baseUrl}/${this.rutaTabla}/${id}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error", error);
      return null;
    }
  },
  // Leer un registro de la tabla por ID y version
  readDataByIdVers: async function (estnumber, vers) {
    try {
      const response = await fetch(
        `${this.baseUrl}/${this.rutaTabla}/${estnumber}/${vers}`
      );
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error", error);
      return null;
    }
  },
  // Actualizar un registro de la tabla por ID
  updateDataById: async function (id, updatedData, accessToken) {
    try {
      const response = await fetch(`${this.baseUrl}/${this.rutaTabla}/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(updatedData),
      });
      console.log(updatedData);
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error", error);
      return null;
    }
  },
  // Eliminar un registro de la tabla por ID
  deleteDataById: async function (id, accessToken) {
    try {
      const response = await fetch(`${this.baseUrl}/${this.rutaTabla}/${id}`, {
        method: "DELETE",
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error", error);
      return null;
    }
  },
  //Cantidad de presupuestos y versiones
  amountDataFetch: async function (accessToken) {
    try {
      const data = await this.fetchData(accessToken);

      // Creamos un Map para almacenar las versiones por estnumber
      const versionsByEstNumber = new Map();

      data.forEach((item) => {
        // Si el estnumber no está en el map, lo agregamos con un nuevo Set
        if (!versionsByEstNumber.has(item.estnumber)) {
          versionsByEstNumber.set(item.estnumber, new Set());
        }
        // Agregamos estVers al Set correspondiente al estnumber
        versionsByEstNumber.get(item.estnumber).add(item.estVers);
      });

      // Contar estnumber distintos
      const distinctEstNumberCount = versionsByEstNumber.size;

      // Contar total de estVers
      let totalEstVersCount = 0;
      versionsByEstNumber.forEach((versions) => {
        totalEstVersCount += versions.size;
      });

      return { distinctEstNumberCount, totalEstVersCount };
    } catch (error) {
      console.log(error);
    }
  },
  // Armar array segun mes
  AmountDate: async function (accessToken) {
    try {
      const data = await this.fetchData(accessToken);
      function countPresupuestosPerMonth(data) {
        // Inicializar un array con 12 ceros, uno por cada mes.
        let monthlyCounts = Array(12).fill(0);

        data.forEach((item) => {
          const month = new Date(item.htimestamp).getMonth(); // Obtener el mes del timestamp (0-enero, 1-febrero, ..., 11-diciembre)
          monthlyCounts[month]++;
        });
        return monthlyCounts;
      }
      return countPresupuestosPerMonth(data);
    } catch (error) {
      console.log(error);
      let monthlyCounts = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      return monthlyCounts; //para prevenir algun error devolvemos el error vacio
    }
  },
  fetchDataHistorico: async function (estimado, accessToken) {
    try {
      const response = await fetch(`${this.baseUrl}/EstimateHeader/Trace/${estimado}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const jsonData = await response.json();
      
      return jsonData;
    } catch (error) {
      console.error("Error", error);
      return null;
    }
  },
  fetchLogHistorico: async function (estnumber, accessToken) {
    try {
      const response = await fetch(`${this.baseUrl}/LogDiferencias/${estnumber}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const jsonData = await response.json();

      return jsonData;
    } catch (error) {
      console.error("Error", error);
      return null;
    }
  },
  fetchDiferenciasVs: async function (estnumber, vers, accessToken) {
    try {
      const response = await fetch(`${this.baseUrl}/Vs/checkchanges/${estnumber}/${vers}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const Data = await response.text();
      return Data;
    } catch (error) {
      console.error("Error", error);
      return null;
    }
  },
  fetchLogHistoricoVersion: async (estnumber, vers, accessToken) => {
    try {
        const response = await fetch(`${this.baseUrl}/LogDiferencias/${estnumber}/${vers}`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
        if(!response.ok){
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.error('Error :', error)
    }
},

};
